import React, { useCallback, useLayoutEffect, useState } from "react";
import "./css/index.css";
import CertificationDetailCard from "../../components/Cards/CertificationDetailCard";
import { useDispatch, useSelector } from "react-redux";
import { PopupChange } from "../../reducers/config";
import { useLocation, useNavigate } from "react-router-dom";
import { GetDetailProject } from "../../api/projectapi";
import { ApprvCard, ProjectBasicDataType } from "../../interface/interface";
import { RootState } from "../../reducers";
import Emty from "../../components/Emty/Emty";
import { officeApi } from "../../api/config";
type LocType = {
  state: string | undefined;
};

/** 인증서 상세 페이지 */
const CertificationDetail = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { state } = useLocation() as LocType;
  const isUpload = useSelector<RootState, boolean>(
    (state) => state.data.certifiFile.isUpload
  );
  const [ProjectData, setProjectData] = useState<
    undefined | ProjectBasicDataType
  >(undefined);
  const [CertDetailData, setCertDetailData] = useState<ApprvCard[]>([]);

  /** 파일 업로드 팝업 오픈 함수 */
  const OpenFileUploader = useCallback(
    (
      e: string | undefined,
      apply_id: string,
      prjt_id: string,
      rcrt_id: string
    ) => {
      dispatch(
        PopupChange({
          active: true,
          type: "cert-file",
          content: {
            url: e ? e : "",
            apply_id,
            prjt_id,
            rcrt_id,
          },
        })
      );
    },
    [dispatch]
  );

  const GetCertification = useCallback(() => {
    if (state) {
      officeApi.get(`/cstm/prjt/cert?prjt_id=${state}`).then((result) => {});
      GetDetailProject(state).then(({ state, data }) => {
        if (state) {
          setCertDetailData(data.rcrt_apprv_lst);
          setProjectData(data);
        }
      });
    }
  }, [state]);

  const NavPortfolio = useCallback(
    (sub: string, content: string, link: string) => {
      navigate("/portfolio/view", {
        state: {
          sub,
          content,
          link,
          img: ProjectData?.prjt_thumbnail,
          prjt_nm: ProjectData?.prjt_nm,
          type: "prjt",
        },
      });
    },
    [navigate, ProjectData]
  );

  /** 상세 데이터 불러오기 임시 */
  useLayoutEffect(() => {
    GetCertification();
    return () => {};
  }, [GetCertification, isUpload]);
  return (
    <main className="certification-detail-page">
      <div className="wrapper">
        <div className="top-content">
          <div className="title-section">
            <button
              className="back-btn"
              onClick={() => {
                navigate(-1);
              }}
            >
              <img src="/assets/common/rightarrow.svg" alt="뒤로가기" />
            </button>
            <div className="title">
              {ProjectData ? ProjectData.prjt_nm : ""}
            </div>
          </div>
          <div className="btn-section">
            <div className="input-wrapper">
              <input type="text" placeholder="검색" />
              <img
                src="/assets/common/search.svg"
                alt="검색"
                className="search-icon"
              />
            </div>
            <button className="search-btn">검색</button>
            <button className="excel-btn">엑셀로 저장하기</button>
          </div>
        </div>
        <div className="content-section">
          <div className="tag-wrapper">
            {tags.map(({ type, text }, idx) => {
              return (
                <div className={`tag ${type}`} key={idx}>
                  {text}
                </div>
              );
            })}
          </div>
          <div className="card-list">
            {CertDetailData.length > 0 ? (
              CertDetailData.map((item, idx) => {
                return (
                  <CertificationDetailCard
                    key={idx}
                    data={item}
                    OpenFile={OpenFileUploader}
                    NavPortfolio={NavPortfolio}
                  />
                );
              })
            ) : (
              <Emty />
            )}
          </div>
        </div>
      </div>
    </main>
  );
};

export default CertificationDetail;

const tags = [
  {
    type: "id",
    text: "아이디",
  },
  {
    type: "email",
    text: "이메일",
  },
  {
    type: "nickname",
    text: "활동명",
  },
  {
    type: "time",
    text: "신청일",
  },
];
